import React from 'react'
import * as styles from 'src/components/page/layout/footer/logos.module.scss'
import { Trustpilot } from 'src/components/page/layout/footer/trustpilot/trustpilot'

export const Logos: React.FC = () => (
  <div className="stk-wrapper stk-wrapper--centered stk-wrapper--middle">
    <div className={styles.logos__item}>
      <Trustpilot />
    </div>

    <a
      href="https://www.refinitiv.com/"
      target="_blank"
      className={styles.logos__item}
      rel="noopener"
    >
      <img
        src="https://app.stockopedia.com/assets/images/refinitiv.png"
        height="20"
        width="99"
        alt="Refinitiv logo"
        loading="lazy"
      />
    </a>

    <a
      href="https://www.financialexpress.net/"
      target="_blank"
      className={styles.logos__item}
      rel="noopener"
    >
      <img
        src="https://app.stockopedia.com/assets/images/financialexpress_x2.png"
        width="331"
        height="39"
        alt="Financial Express logo"
        loading="lazy"
      />
    </a>
  </div>
)
